import HotCity from '../components/hot-city'
import BreadCrumb from '../components/bread-crumb'
import CityLayout from '../layout/city-layout'
import { AREA_PANEL_PROPS } from '../props/area-panel'
import '../style/area-panel.scss'
import {
  setAreaTreeRootNode,
  getAreaTreeNodeById,
  getAreaTreeNodeFirstChid,
  cookingAreaTreeNode,
  createAreaPanelBaseData,
  getAreaTreeNodeChildren,
  getAreaTreeParentNode,
  isJumpNextLevel,
  createParentItem
} from '../data/store'
import { getAreaNodeChildrenById, getInfoByDistrictIds, createBaseAreaDataById } from '../data/api'
import { createBreadCrumbData } from '../data/bread-crumb'
import { isPreventDownOnLevel } from '../utils/tools'
import { isFunction } from 'lodash'

const { breadCrumbData, breadCrumbLabel } = createBreadCrumbData()
export default {
  props: AREA_PANEL_PROPS,
  data () {
    return {
      areaRenderData: [],
      breadCrumbData,
      breadCrumbLabel,
      lodaing: false
    }
  },
  render () {
    const props = this.$props
    const [slot] = this.$slots.default || []

    const handleClickEvent = this.handleClickItemEvent

    const hotCityAttrs = {
      props: {
        hotCity: props.hotCity
      }
    }

    const breadCrumbAttrs = {
      props: {
        breadCrumbData: this.breadCrumbData,
        breadCrumbLabel: this.breadCrumbLabel,
      }
    }

    const renderAreaData = () => {
      return this.areaRenderData.map(renderData => {
        if (!renderData.length) return null
        const cityLayoutAttrs = {
          props: {
            renderData
          }
        }
        return <CityLayout {...cityLayoutAttrs}>
          {{
            cityItem: (_props) => {
              return slot.cityItem({
                ..._props,
                handleClickEvent
              })
            },
            label: (_props) => {
              return slot.cityItem({
                ..._props,
                handleClickEvent
              })
            },

          }}
        </CityLayout>
      })
    }
    const cityLayoutChildren = renderAreaData()
    return <div class='kye-area-content-layout'>
      {
        props.showHotCity ? <HotCity {...hotCityAttrs}>
          {{
            hotItem: (_props) => {
              return slot.cityItem({
                ..._props,
                handleClickEvent: this.handleClickHotItemEvent
              })
            }
          }}
        </HotCity> : null
      }
      <BreadCrumb {...breadCrumbAttrs}>
        {{
          crumbItem: (_props) => {
            return slot.cityItem({
              ..._props,
              handleClickEvent: this.handleClickBreadCrumbItemEvent
            })
          }
        }}
      </BreadCrumb>
      <div class='content-wrap' v-loading={this.lodaing}>
        {
          cityLayoutChildren
        }
      </div>
    </div>
  },
  methods: {
    // 改变面包屑数据
    _createBreadCrumbData (item) {
      const { breadCrumbData, breadCrumbLabel } = createBreadCrumbData(item)
      this.breadCrumbData = breadCrumbData
      this.breadCrumbLabel = breadCrumbLabel
    },
    // 点击面包屑的项。反推展示数据
    handleClickBreadCrumbItemEvent ({item}) {
      // console.log(item, '-------点击面包屑的项。反推展示数据')
      const { districtID } = item
      const parent = getAreaTreeParentNode(districtID)
      const isRegion = +parent.level === 1
      if (parent) {
        // 为1 表示展示大区的数据
        if (isRegion) {
          this._createAreaPanelBaseData()
        } else {
          this.handleClickItemEvent({item: parent}, false)
        }
        // 这里比较特殊。面包屑的为大区的时候，被选中的为自己。 即省份的数据
        this.handleEvent(isRegion ? districtID : parent.districtID)
      }
      this.$emit('updateAreaPanel')
    },
    // 修改面板渲染数据
    changeAreaRenderData (data) {
      this.areaRenderData = data
    },
    // 获取节点的子节点们
    _getAreaTreeNodeChildren (districtID) {
      const children = getAreaTreeNodeChildren(districtID)
      if (children) {
        // 直接取内存中平铺树中的 节点数据以及兄弟节点
        this.changeAreaRenderData([children])
        this._createBreadCrumbData(children[0])
      }
      return children
    },
    // 点击热门城市项时的回调
    handleClickHotItemEvent ({item}) {
      this.handelLodaingEvent(async () => {
        // console.log(item, '-----i')
        const { districtID } = item
        // 判断是否存在子节点. 不存在则调用接口获取
        if (!getAreaTreeNodeChildren(districtID)) {
          const result = await getInfoByDistrictIds([districtID])
          if (result) {
            this._cookingAreaTreeNode(result.childrenNode, result)
          }
        }
        // TODO热门城市需要根据 level来适配。这里不行
        const flatTreeNode = getAreaTreeNodeById(districtID)
        this.handleClickItemEvent({item: flatTreeNode})
      })
    },
    async handelLodaingEvent (callback) {
      try {
        this.lodaing = true
        if (isFunction(callback) && callback) {
          await callback()
        }
        this.lodaing = false
      } catch (error) {
        console.info(error)
      } finally {
        this.lodaing = false
        this.$emit('updateAreaPanel')
      }
    },
    // 下拉框使用。
    // 给id 展示自己以及兄弟节点
    async patchAreaTreeData (item) {
      // console.log(item, '-----id查询----')
      const { districtID } = item
      let flatTreeNode = getAreaTreeNodeById(districtID)
      if (!flatTreeNode) {
        // 获取整个数据，重新添加
        const result = await getInfoByDistrictIds([districtID])
        if (result) {
          this._cookingAreaTreeNode(result.childrenNode, result)
          flatTreeNode = getAreaTreeNodeById(districtID)
        }
      }
      const params = {
        item: flatTreeNode,
      }
      await this.handleClickItemEvent(params)
      return flatTreeNode
    },
    // 点击渲染面板中每一项的回调
    async handleClickItemEvent (obj, goNextLevel = true) {
      await this.handelLodaingEvent(async () => {
        // console.log(item)
        const { item, type, emit = true } = obj
        if (type === '_label' || !item) {
          return
        }
        const { districtID, parents } = item
        emit && this.handleEvent(districtID)
        if (this._isPreventDownOnLevel(item.level, 'greaterEqual')) {
          console.info('----层级限制----')
          // 如果限制了层级，但是这个时候需要判断，当前数据是否为需要展示的数据。不是，则需要更正。
          const [firstList] = this.areaRenderData || []
          const [firstItem] = firstList || []
          const { parentId } = firstItem || {}
          if (parentId !== item.parentId) {
            this._getAreaTreeNodeChildren(item.parentId)
          }
          return
        }
        const children = getAreaTreeNodeChildren(districtID)
        if (!children) {
          const child = await getAreaNodeChildrenById(districtID)
          if (child && child.length) {
            this._cookingAreaTreeNode(child, item, parents)
          }
        }
        this._getAreaTreeNodeChildren(districtID)
        // 如果当前节点命中了 下级节点 在业务层无作用时。就多调用一次。
        if (goNextLevel) {
          this.moveToNextLevel(districtID)
        }
      })
    },
    moveToNextLevel (districtID) {
      const flatTreeNode = getAreaTreeNodeById(districtID)
      if (isJumpNextLevel(flatTreeNode)) {
        const child = getAreaTreeNodeFirstChid(districtID)
        if (child) {
          this.handleClickItemEvent({item: child, emit: this.$props.confirmNextLevel})
        }
      }
    },
    async createPanelBaseData () {
      // 添加loading
      const result = await createBaseAreaDataById()
      if (result) {
        setAreaTreeRootNode(result)
        const { childrenNode } = result
        this._cookingAreaTreeNode(childrenNode, result)
        this._createAreaPanelBaseData()
      }
    },
    _cookingAreaTreeNode (childrenNode, parentNode, ancestorNode = []) {
      const parents = [...ancestorNode, createParentItem(parentNode)]
      if (childrenNode && childrenNode.length) {
        cookingAreaTreeNode(childrenNode, parents)
      }
    },
    _isPreventDownOnLevel (level, type) {
      return isPreventDownOnLevel(level, this.$props.level, type)
    },
    handleEvent (districtID) {
      const flatTreeNode = getAreaTreeNodeById(districtID)
      this.$emit('area-item-click', flatTreeNode)
    },
    _createAreaPanelBaseData () {
      const data = createAreaPanelBaseData()
      this.changeAreaRenderData(data)
      this._createBreadCrumbData()
    }
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/layout/area-panel.js